/// <reference lib="webworker" />

import { ReminderWorkerMessage, ReminderWorkerMessageItem } from './reminder.model-shared';

export const enum ReminderWorkerMessageTypes {
  RENEW = 'RENEW',
  CLEAR = 'CLEAR',
  CLOSE = 'CLOSE',
  NOTIFY = 'NOTIFY',
  ADD = 'ADD',
  PING = 'PING',
}

export const createWorker = function () {
  let scheduledNotifications = [];

  addEventListener('message', ({ data }) => {
    const message: ReminderWorkerMessage = data;

    if (message.type === 'PING') {
      postMessage({ type: 'pong', message: message.message });
    } else if (message.type === 'RENEW') {
      renewNotifications(message.items);
    } else if (message.type === 'ADD') {
      addNotifications(message.items);
    } else if (message.type === 'CLEAR') {
      clearNotifications();
    } else if (message.type === 'CLOSE') {
      close();
    }
  });

  function clearNotifications() {
    scheduledNotifications.forEach(scheduledNotification => clearTimeout(scheduledNotification));
    scheduledNotifications = [];
  }

  function renewNotifications(reminders: ReminderWorkerMessageItem[]) {
    clearNotifications();
    scheduleReminders(reminders);
  }

  function addNotifications(reminders: ReminderWorkerMessageItem[]) {
    scheduleReminders(reminders);
  }

  function scheduleReminders(reminders: ReminderWorkerMessageItem[]) {
    if (!reminders) {
      return;
    }

    reminders.forEach(reminder => {
      const now = new Date().getTime();
      const time = new Date(reminder.time).getTime();
      if (time <= now) {
        postMessage({ type: 'NOTIFY', items: [reminder] } as ReminderWorkerMessage);
      } else {
        const reminderTimeout = setTimeout(() => {
          postMessage({ type: 'NOTIFY', items: [reminder] } as ReminderWorkerMessage);
        }, time - now);

        scheduledNotifications.push(reminderTimeout);
      }
    });
  }
};
